import { toPng } from "html-to-image";
import { toast } from "sonner";

// Renders a node to a 1080px PNG, then native-shares it or downloads it.
export async function shareNodeAsPng(node, name) {
  await new Promise((r) => setTimeout(r, 200));
  const dataUrl = await toPng(node, { width: 1080, height: 1080, pixelRatio: 2, cacheBust: true });
  const blob = await (await fetch(dataUrl)).blob();
  const file = new File([blob], `${(name || "garden").replace(/\s+/g, "-")}.png`, { type: "image/png" });
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    await navigator.share({ files: [file], title: name, text: "My garden plan 🌱 #SproutLog" });
  } else {
    const a = document.createElement("a");
    a.href = dataUrl; a.download = file.name; a.click();
    toast.success("Image saved — share it on Instagram!");
  }
}
